var map = {
	"./agreement-contract.jpg": 2583,
	"./certificate-frame.jpg": 3207,
	"./china.png": 1387,
	"./china.svg": 6625,
	"./close.svg": 8484,
	"./english.png": 6322,
	"./english.svg": 160,
	"./france.png": 421,
	"./france.svg": 2585,
	"./germany.png": 489,
	"./germany.svg": 99,
	"./instagram.svg": 2708,
	"./italy.png": 8303,
	"./japan.png": 6154,
	"./japan.svg": 9812,
	"./korean.png": 3184,
	"./korean.svg": 3572,
	"./logo-white.svg": 6169,
	"./logo.png": 2077,
	"./poland.png": 8124,
	"./poland.svg": 868,
	"./spain.png": 7089,
	"./spain.svg": 9035,
	"./sprites.svg": 2954,
	"./turkish.png": 3154,
	"./upload.svg": 1739,
	"./words-map.png": 2840,
	"./сheck.svg": 8174
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1215;